import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";

export const FloatingWhatsApp = () => (
  <motion.a
    data-testid="floating-whatsapp-button"
    href={waLink("Olá, estou no site da Melo Vistos e gostaria de atendimento imediato.")}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full border border-emerald-400/40 bg-navy-900/90 py-2.5 pl-3 pr-5 shadow-[0_16px_40px_-12px_rgba(16,185,129,0.4)] backdrop-blur-md transition-colors duration-300 hover:border-emerald-400"
    aria-label="Falar no WhatsApp"
  >
    <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500 text-navy-950">
      <MessageCircle className="h-5 w-5" />
      <span className="pulse-dot absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-emerald-400" />
    </span>
    <span className="text-left leading-tight">
      <span className="block text-xs font-semibold text-slate-100">WhatsApp</span>
      <span className="block font-mono-tech text-[9px] tracking-widest text-emerald-400">
        ONLINE AGORA
      </span>
    </span>
  </motion.a>
);
